@if (type() !== 'dot') {
  <span class="badge-text">
    @if (!count) {
      <ng-content></ng-content>
    }
    @if (count) {
      <span>{{ count }}</span>
    }
  </span>
}
<mat-icon
  class="badge-background"
  [ngClass]="color ? 'exl-' + color : undefined"
  muloSvgViewbox
  [style.color]="hexColor ? color : undefined"
  [svgIcon]="type() === 'icon' ? 'decagram' : 'circle-dot'"
  >
</mat-icon>
@if (icon) {
  <mat-icon [class.mat-icon-rtl-mirror]="rtlMirrorIcon()" [svgIcon]="icon" class="exl-{{ color }}"></mat-icon>
}
